<div class="notification-filter-bar" [formGroup]="filterForm">
  <div class="filters-row">
    <div class="search-container">
      <svg class="search-icon" aria-hidden="true" width="16" height="16" viewBox="0 0 20 20" fill="none">
        <path d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16zM18 18l-4-4" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <input
        type="text"
        class="search-input"
        formControlName="searchText"
        [placeholder]="'notifications.filters.searchPlaceholder' | translate">
      <button *ngIf="filterForm.get('searchText')?.value" class="clear-btn search-clear"
              (click)="clearSearchText()"
              [title]="'common.clear' | translate">×</button>
    </div>
    <div class="spacer"></div>
    <button class="advanced-filters-btn" (click)="toggleAdvancedFilters()"
      [matTooltip]="'notifications.filters.advancedFilters' | translate" [class.active]="showAdvancedFilters">
      <img src="assets/icons/adjustments.svg" alt="filter" class="btn-icon" />
      <span *ngIf="advancedFiltersCount > 0" class="filter-badge">
        {{ advancedFiltersCount }}
      </span>
    </button>
    <button *ngIf="activeFiltersCount > 0" class="clear-filters-btn" (click)="clearFilters()">
      <span>{{ 'notifications.filters.clear' | translate }}</span>
    </button>
  </div>
  <div class="advanced-filters" *ngIf="showAdvancedFilters">
    <div class="advanced-filters-grid">
      <div class="form-group filter-field">
        <label>{{ 'notifications.filters.dateRange' | translate }}</label>
        <div class="date-range-filter">
          <app-date-input id="dateFrom" formControlName="dateFrom" [fullWidth]="true" [showLabel]="false"
            [clearable]="true"></app-date-input>
          <span class="date-separator">-</span>
          <app-date-input id="dateTo" formControlName="dateTo" [fullWidth]="true" [showLabel]="false"
            [clearable]="true"></app-date-input>
        </div>
      </div>
      <div class="form-group filter-field">
        <label>{{ 'notifications.filters.sortBy' | translate }}</label>
        <div class="custom-select-wrapper">
          <select class="form-control" [value]="sortValue" (change)="onSortChange($event)">
            <option value="1:Desc">{{ 'notifications.filters.newestFirst' | translate }}</option>
            <option value="1:Asc">{{ 'notifications.filters.oldestFirst' | translate }}</option>
            <option value="2:Desc">{{ 'notifications.filters.highPriorityFirst' | translate }}</option>
          </select>
          <img src="assets/icons/chevron-down.svg" alt="" class="custom-select-arrow">
        </div>
      </div>
      <div class="form-group filter-field">
        <label>{{ 'notifications.filters.category' | translate }}</label>
        <div class="custom-select-wrapper">
          <select class="form-control" formControlName="category">
            <option [ngValue]="null">{{ 'notifications.filters.all' | translate }}</option>
            <option *ngFor="let option of categoryOptions" [ngValue]="option.value">
              {{ option.label }}
            </option>
          </select>
          <img src="assets/icons/chevron-down.svg" alt="" class="custom-select-arrow">
        </div>
      </div>
      <div class="form-group filter-field">
        <label>{{ 'notifications.filters.type' | translate }}</label>
        <div class="custom-select-wrapper">
          <select class="form-control" formControlName="type">
            <option [ngValue]="null">{{ 'notifications.filters.all' | translate }}</option>
            <option *ngFor="let option of typeOptions" [ngValue]="option.value">
              {{ option.label | translate }}
            </option>
          </select>
          <img src="assets/icons/chevron-down.svg" alt="" class="custom-select-arrow">
        </div>
      </div>
      <div class="form-group filter-field">
        <label>{{ 'notifications.filters.priority' | translate }}</label>
        <div class="custom-select-wrapper">
          <select class="form-control" formControlName="priority">
            <option [ngValue]="null">{{ 'notifications.filters.all' | translate }}</option>
            <option *ngFor="let option of priorityOptions" [ngValue]="option.value">
              {{ option.label | translate }}
            </option>
          </select>
          <img src="assets/icons/chevron-down.svg" alt="" class="custom-select-arrow">
        </div>
      </div>
      <div class="form-group filter-field">
        <label>{{ 'notifications.filters.status' | translate }}</label>
        <div class="custom-select-wrapper">
          <select class="form-control" formControlName="status">
            <option [ngValue]="null">{{ 'notifications.filters.all' | translate }}</option>
            <option *ngFor="let option of statusOptions" [ngValue]="option.value">
              {{ option.label | translate }}
            </option>
          </select>
          <img src="assets/icons/chevron-down.svg" alt="" class="custom-select-arrow">
        </div>
      </div>
      <div class="form-group filter-field tags-filter-field">
        <label>{{ 'notifications.filters.tags' | translate }}</label>
        <div class="tags-filter-container">
          <div class="tags-input-wrapper">
            <input
              type="text"
              class="tags-search-input"
              [formControl]="tagInputControl"
              [placeholder]="selectedTags.length > 0
                ? ('notifications.filters.tagsSelected' | translate:{count: selectedTags.length})
                : ('notifications.filters.tagsPlaceholder' | translate)"
              (focus)="showTagDropdown = true"
              autocomplete="off"
            />
            <svg class="dropdown-arrow" [class.open]="showTagDropdown" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="tags-dropdown" *ngIf="showTagDropdown">
              <ul *ngIf="(filteredTags | async) as tags">
                <li *ngFor="let tag of tags"
                    (mousedown)="toggleTagSelection(tag)"
                    [class.selected]="isTagSelected(tag)">
                  <span class="checkbox-icon">
                    <svg *ngIf="isTagSelected(tag)" width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M11.5 3.5L5.5 9.5L2.5 6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </span>
                  {{ tag.name }}
                </li>
                <li *ngIf="tags.length === 0" class="no-results">
                  {{ 'notifications.filters.noTagsFound' | translate }}
                </li>
              </ul>
            </div>
          </div>
          <div class="selected-tags-row" *ngIf="selectedTags.length > 0">
            <span class="tag-chip" *ngFor="let tag of selectedTags">
              {{ tag.name }}
              <button type="button" class="tag-remove" (click)="removeTag(tag)">&times;</button>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="popular-tags-row" *ngIf="popularTags.length > 0 && selectedTags.length === 0">
      <small class="popular-tags-label">{{ 'notifications.filters.popularTags' | translate }}:</small>
      <button
        *ngFor="let tag of popularTags"
        type="button"
        class="tag-button"
        (click)="addTagFromButton(tag)">
        {{ tag.name }}
      </button>
    </div>
  </div>
</div>